import Main from 'manuals/containers/Main'

export const RouteConfig = [
  {
    path: '/manuals',
    component: Main,
  },
]
